import createStore from 'unistore'

import { is768Query } from '~/core/scripts/mediaquery-helper';
const isSmallScreen = !is768Query();

export default createStore({
  data: null,
  selectedParty: null,
  tooltipPos: {},
  tooltipData: null,
  detailData: null,
  detailPos: {},
  geocoderLatLng: [],
  selectedAnalysis: {},
  analysisOverlayIsOpen: false, // we only use this in mobile devices
  hasDataAnalysis: typeof baseconfig.app.dataAnalysis !== 'undefined',
  isAnalysisMode: typeof baseconfig.app.dataAnalysis === 'undefined' && !isSmallScreen
});
